export default "__VITE_ASSET__7bCSWf3vQpdgBz9NtfZ5_w__"